import React, { useState } from "react";
import userIcon from "@/assets/images/userIcon.png";
import exitIcon from "@/assets/icons/exit.svg";
import { IAdminFireBase } from "@/store/models/admin.models";
import styles from "./TopBar.module.scss";
import { Button, Modal } from "@mui/material";
import { useSignOut } from "@/hooks/useSignOut";
import homeIcon from "@/assets/icons/home.svg";
import { useNavigate } from "react-router-dom";

type Props = {
  currentUser?: IAdminFireBase;
};

const TopBar = ({ currentUser }: Props) => {
  const signOut = useSignOut();
  const navigate = useNavigate();
  const [isOpenModal, setIsOpenModal] = useState(false);

  const handleExit = () => {
    setIsOpenModal((prev) => !prev);
  };

  return (
    <>
      <header className={styles.topBar}>
        <Button
          sx={{
            textTransform: "capitalize",
            height: "44px",
            width: "174px",
            backgroundColor: "#5570F1",
            border: "none",
            borderRadius: "12px",
            fontSize: "16px",
            "&:hover": {
              backgroundColor: "#1f0163",
            },
            display: "flex",
            alignItems: "center",
            gap: '6px'
          }}
          variant="contained"
          onClick={() => navigate("/")}
        >
          <img
            src={homeIcon}
            alt="home"
            style={{
              width: "24px",
              height: "24px",
            }}
          />
          <p>Home</p>
        </Button>
        <div className={styles.topBarRight}>
          <div className={styles.user}>
            <img
              src={currentUser?.photoUrl || userIcon}
              alt="user icon"
              style={{
                width: "36px",
                height: "36px",
              }}
            />
            <div className={styles.userInfo}>
              <p className={styles.userInfoEmail}>{currentUser?.email}</p>
              <p className={styles.userInfoType}>
                {currentUser ? currentUser?.status : ""}
              </p>
            </div>
          </div>
          <button className={styles.exitBtn} onClick={handleExit}>
            <img src={exitIcon} alt="exit" />
          </button>
        </div>
      </header>
      {isOpenModal && (
        <Modal
          aria-labelledby="modal-exit"
          aria-describedby="Are you sure you want to log out? Click exit or cancel"
          open={isOpenModal}
          onClose={() => setIsOpenModal(false)}
        >
          <div className={styles.modalContainer}>
            <h3 className={styles.modalTitle}>
              Are you sure you want to log out?
            </h3>

            <div className={styles.btns}>
              <Button
                sx={{
                  textTransform: "capitalize",
                  height: "44px",
                  width: "150px",
                  backgroundColor: "#000",
                  fontWeight: "600",
                  border: "none",
                  borderRadius: "12px",
                  "&:hover": {
                    backgroundColor: "#FF0000",
                  },
                }}
                variant="contained"
                onClick={signOut}
              >
                Exit
              </Button>

              <Button
                variant="outlined"
                sx={{
                  textTransform: "capitalize",
                  height: "44px",
                  width: "150px",
                  fontWeight: "600",
                  border: "1px solid #5570F1",
                  color: "#5570F1",
                  borderRadius: "12px",
                }}
                onClick={() => setIsOpenModal(false)}
              >
                Cancel
              </Button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default TopBar;

